export default __webpack_public_path__ + "static/media/unified_streaming.e8427895.svg";